var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "email",
    class: {
      'mb': _vm.wayType === 'm-email'
    }
  }, [_c('email-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regType === 'input',
      expression: "regType === 'input'"
    }],
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "inputEmail": _vm.inputEmailHandle
    }
  }), _vm._v(" "), _c('email-login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regType === 'login',
      expression: "regType === 'login'"
    }],
    attrs: {
      "name": _vm.email,
      "wayType": _vm.wayType
    },
    on: {
      "success": _vm.successHandle,
      "showForget": _vm.showForgetHandle,
      "inputEmail": _vm.inputEmailHandle
    }
  }), _vm._v(" "), _c('email-reg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regType === 'reg',
      expression: "regType === 'reg'"
    }],
    attrs: {
      "name": _vm.email,
      "wayType": _vm.wayType
    },
    on: {
      "success": _vm.successHandle,
      "inputEmail": _vm.inputEmailHandle
    }
  }), _vm._v(" "), _c('email-act', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regType === 'sure',
      expression: "regType === 'sure'"
    }],
    attrs: {
      "name": _vm.email,
      "token": _vm.token,
      "wayType": _vm.wayType
    },
    on: {
      "success": _vm.successHandle
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };